/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { CategoryCategoryMetaTable } from "./CategoryCategoryMetaTable";
import { CategoryFieldMetaTable } from "./CategoryFieldMetaTable";
import { CategoryMetaTable } from "./CategoryMetaTable";
import { CategoryTagMetaTable } from "./CategoryTagMetaTable";
import { EnvService } from "namirasoft-core";
import { FieldCategoryMetaTable } from "./FieldCategoryMetaTable";
import { FieldFieldMetaTable } from "./FieldFieldMetaTable";
import { FieldMetaTable } from "./FieldMetaTable";
import { FieldTagMetaTable } from "./FieldTagMetaTable";
import { NSBaseMetaDatabase } from "namirasoft-site";
import { NamirasoftFieldServer } from "../NamirasoftFieldServer";
import { TokenManager } from "namirasoft-account";

export class NamirasoftFieldMetaDatabase extends NSBaseMetaDatabase<NamirasoftFieldServer>
{
    private manager?: TokenManager;
    private onError?: (error: Error) => void;
    public override tables: {
        category: CategoryMetaTable,
        category_category: CategoryCategoryMetaTable,
        category_field: CategoryFieldMetaTable,
        category_tag: CategoryTagMetaTable,
        field: FieldMetaTable,
        field_category: FieldCategoryMetaTable,
        field_field: FieldFieldMetaTable,
        field_tag: FieldTagMetaTable,
    };
    constructor(manager?: TokenManager, onError?: (error: Error) => void)
    {
        super({ id: "prd-a9fb78ad0b6e4cd3", name: "Namirasoft Field", headline: "Dynamic Table Enhancement", description: "Add categorization, new fields, etc. to your entities to enhance your main table easily. You can customize your data structure to better fit your needs and improve data organization and accessibility.", logo: "https://static.namirasoft.com/image/namirasoft/field/logo/base.png", link: "https://field.namirasoft.com" });
        this.manager = manager;
        this.onError = onError;
        this.tables = {
            category: new CategoryMetaTable(this),
            category_category: new CategoryCategoryMetaTable(this),
            category_field: new CategoryFieldMetaTable(this),
            category_tag: new CategoryTagMetaTable(this),
            field: new FieldMetaTable(this),
            field_category: new FieldCategoryMetaTable(this),
            field_field: new FieldFieldMetaTable(this),
            field_tag: new FieldTagMetaTable(this),
        };
    }
    override getServer(): NamirasoftFieldServer
    {
        if (!this.manager || !this.onError)
            throw new Error("Arguments of NamirasoftFieldMetaDatabase (manager, onError) are required for server operations.")
        let NAME = NSBaseMetaDatabase.getServerBaseURL(this.product.name);
        let BASE_URL = new EnvService(NAME, true).getString();
        return new NamirasoftFieldServer(BASE_URL, this.manager, this.onError);
    }
};